import React from 'react';
import './Help.styles.scss';

const Help = () => {
	return (
		<div className="helpComponent">
			<h3 className="title">Help</h3>
			<div className="content">
				<div className="tip">
					<div className="title">$ORE</div>

					<div className="tip">
						$ORE is collected into your ship's storage. To extract $ORE into your permanent storage summon the platform (Press "F"){' '}
					</div>
					<div className="tip">While extracting $ORE into the platform, your ship is safe and cannot be hit by the asteroid</div>
					<div className="tip">
						All collected $ORE is currently for testing purposes only. Your $ORE balance will be reset several times during testing, and
						will not be permanent until the game is released to public.
					</div>
				</div>

				<div className="tip">
					<div className="title">Navigation</div>
					<div className="tip">
						<span>W</span> Acceleration
					</div>
					<div className="tip">
						<span>S</span> Brake
					</div>
					<div className="tip">
						<span>AD</span> Ship rotation
					</div>
					<div className="tip">
						<span>QE</span> Strafe
					</div>
					<div className="tip">
						Use <span>F</span> key to call ORE extraction platform
					</div>
				</div>
			</div>
		</div>
	);
};

export default Help;
